import { Box, Stack } from "@mui/material";
import AutoCompleteList from "components/AutoCompleteList";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { getHsnThunk } from "store/reducers/product/productGstSlice";

const GstPanel = ({ filter, setFilter }) => {
  useEffect(() => {
    dispatch(getHsnThunk());
  }, []);
  const hsns = useSelector((state) => state.productGst.HSNS);
  return (
    <Box>
      <Stack direction="column" spacing={1.5}>
        <AutoCompleteList
          items={hsns}
          name="HSNCODE"
          label="Filter by HSN No"
          setValue={(value) => {
            setFilter({ ...filter, hsn: value });
          }}
          value={filter.hsn}
        />
      </Stack>
    </Box>
  );
};

export default GstPanel;
